import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconStatusbarMouseLeftDrag = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeMiterlimit: 1.5,
	clipRule: "evenodd",
	viewBox: "0 0 71 59",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 4.17,
			d: "M2.083 29.159v11.883A15.175 15.175 0 0 0 17.291 56.25h7.085a15.174 15.174 0 0 0 15.207-15.208V17.291A15.174 15.174 0 0 0 24.376 2.083h-3.543"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "nonzero",
			d: "M16.667 0C7.406.352 0 7.957 0 17.281V25h16.667z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeMiterlimit: 4,
			strokeWidth: 4.17,
			d: "M68.75 27.083H47.917M60.417 35.417h-12.5"
		})
	]
});
export default SvgIconStatusbarMouseLeftDrag;
